import { APP_CONFIG } from 'mangools-commons/dist/configs/app';
import queryString from 'query-string';
import { parse, parseMeta, parseParams } from 'sources/parsers/ResultDataParser';

import ErrorCodes from 'mangools-commons/dist/constants/ErrorCodes';
import HumanService from 'mangools-commons/dist/services/HumanService';
import { TechnicalErrorReportService } from 'mangools-commons/dist/services/TechnicalErrorReportService';

// Constants
const ENDPOINT = '/related-keywords';

/**
 * Data source class handling communication with API for result list data.
 */
class ResultSource {
    static getData({ accessToken, params }) {
        const query = queryString.stringify({
            kw: params.query,
            language_id: params.languageId,
            location_id: params.locationId,
            // relatedKeywordFlow: 3 // Force dataforseo
        });

        const requestURL = `${APP_CONFIG.API_HOST}${APP_CONFIG.API_PATH}${ENDPOINT}?${query}`;

        return fetch(requestURL, {
            method: 'GET',
            mode: 'cors',
            headers: {
                'X-Access-Token': accessToken || '',
                'X-Human-Token': HumanService.gen(),
                'X-Mangools-Client': 'app',
            },
        })
            .then(response => {
                if (response.ok) {
                    return response
                        .json()
                        .then(data => ({
                            error: false,
                            payload: {
                                // eslint-disable-next-line no-underscore-dangle
                                relatedKeywordId: data._id,
                                data: parse(data),
                                meta: parseMeta(data),
                                params: parseParams(data),
                            },
                        }))
                        .catch(ex => {
                            const payload = {
                                requestURL,
                                status: ErrorCodes.PARSE_ERROR,
                                text: ex.toString(),
                            };

                            TechnicalErrorReportService.report({ ...payload, method: 'GET' });

                            return { error: true, payload };
                        });
                } else {
                    return response.json().then(e => {
                        const payload = {
                            requestURL,
                            status: response.status,
                            text: e.error ? e.error.message : null,
                            type: e.error ? e.error.type : null,
                            retryAfter: e.error ? e.error.retry_after : null,
                        };

                        TechnicalErrorReportService.report({ ...payload, method: 'GET' });

                        return { error: true, payload };
                    });
                }
            })
            .catch(ex => {
                const payload = {
                    requestURL,
                    status: ErrorCodes.FETCH_ERROR,
                    text: ex.toString(),
                };

                TechnicalErrorReportService.report({ ...payload, method: 'GET' });

                return { error: true, payload };
            });
    }
}

export default ResultSource;
